// extracted by mini-css-extract-plugin
export var bounce = "_om-1";
export var generatingText = "_om-6";
export var lightning = "_om-4";
export var popup = "_om-5";
export var progressBar = "_om-7";
export var progressFill = "_om-8";
export var progressShimmer = "_om-9";
export var progressText = "_om-a";
export var shimmer = "_om-3";
export var uploadIcon = "_om-0";
export var uploadingText = "_om-2";